<template>
  <div id="create-asset">
    <div class="container">
      <div class="asset-name tw-mb-8 tw-mx-auto">
        <div class="tw-mb-8">
          <h3 class="tw-text-black-dark tw-font-bold tw-text-lg tw-mb-2">
            Asset Details
          </h3>
          <p class="tw-text-black-light">
            Please enter the name of the asset you want to create.
          </p>
        </div>
        <div class="tw-bg-white tw-rounded-lg">
          <form
            @submit.prevent="setName"
            class="form tw-relative tw-w-full tw-py-12 tw-mx-auto"
          >
            <TextInput
              :placeHolder="
                orgDetails.asset ? 'Search for asset' : 'Create asset'
              "
              label="Name of Asset"
              type="text"
              fieldType="text"
              id="asset_name"
              name="asset_name"
              :text="payload.assetName"
              :showLabel="true"
              @set="setAssetName"
              @valid="assetNameValid"
            />
            <div
              class="tw-absolute tw-w-full tw-bg-white tw-border tw-rounded tw-p-4"
              v-if="showSearchResult"
            >
              <div class="tw-flex tw-justify-between tw-my-2">
                <p class="tw-text-gray tw-font-semibold">Search result</p>
                <img
                  class="tw-cursor-pointer"
                  src="@/assets/img/noti-cancel.svg"
                  alt="cancel"
                  @click="showSearchResult = false"
                />
              </div>
              <ul class="tw-max-h-60 tw-overflow-scroll">
                <li
                  v-for="(asset, index) in searchResult"
                  :key="index"
                  class="tw-cursor-pointer tw-rounded tw-p-2 hover:tw-bg-primary hover:tw-text-white"
                  @click="setName(asset)"
                >
                  {{ asset.name }}
                </li>
              </ul>
              <EmptyState v-if="searchResult.length === 0">
                <template v-slot:message>
                  <p class="message tw-text-center tw-text-gray tw-my-3">
                    This asset does not exist.
                  </p>
                </template>
              </EmptyState>
            </div>
            <Btn class="tw-mt-10" title="Create Asset" />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import AssetInfoForm from "@/components/asset/forms/AssetInfoForm.vue";
// import InvestmentMemoForm from "@/components/asset/forms/InvestmentMemoForm.vue";
// import TokenDetailAddressForm from "@/components/asset/forms/TokenDetailAddressForm.vue";
// import FoundersForm from "@/components/asset/forms/FoundersForm.vue";
// import SocialsForm from "@/components/asset/forms/SocialsForm.vue";
import TextInput from "@/components/general/TextInput.vue";
import Btn from "@/components/general/BtnComponent.vue";
import EmptyState from "@/components/notification/EmptyState.vue";
import { setItem } from "@/utils/storage.js";

export default {
  name: "CreateAsset",

  components: {
    // AssetInfoForm,
    // InvestmentMemoForm,
    // TokenDetailAddressForm,
    // FoundersForm,
    // SocialsForm,
    TextInput,
    EmptyState,
    Btn,
  },

  computed: {
    ...mapState({
      assetDetails: (state) => state.assetModule.assetDetails,
      orgDetails: (state) => state.organisationModule.organisationDetails,
      searchResult: (state) => state.assetModule.searchResult,
    }),
  },

  data() {
    return {
      showSearchResult: false,
      showCreateAsset: false,
      validateForm: false,
      validInput: {
        assetName: false,
      },
      debounce: null,
      payload: {
        assetName: "",
      },
    };
  },

  methods: {
    ...mapActions("assetModule", ["searchAsset"]),

    // getAsset() {
    //   setTimeout(() => {
    //     if (!this.validInput.assetName) {
    //       return this.showToast({
    //         description: "Please fill all input field correctly",
    //         display: true,
    //         type: "error",
    //       });
    //     }
    //     // this.searchAsset(this.payload.assetName);
    //   }, 500);
    // },

    setName(asset) {
      if (!asset?.name) setItem("asset_name", this.payload.assetName);
      this.$router.push({
        name: "CreateAssetInfo",
        query: { asset: asset._id },
      });
    },

    setAssetName(text) {
      clearTimeout(this.debounce);
      this.payload.assetName = text;
      this.debounce = setTimeout(async () => {
        if (!this.payload.assetName) return;
        await this.searchAsset(this.payload.assetName);
      }, 500);
    },

    assetNameValid(valid) {
      this.validInput.assetName = valid;
    },
  },

  watch: {
    searchResult() {
      if (this.searchResult.length) {
        this.showSearchResult = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#create-asset {
  .container {
    @include fadeIn;

    .asset-name {
      max-width: 692px;

      .form {
        max-width: 336px;
      }
    }

    @media screen and (min-width: 1024px) {
      max-width: 1280px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
